"use client";
import { useEffect } from "react";
import { useAtom } from "jotai";
import SVG from "react-inlinesvg";
import MethodCards from "@/components/utils/MethodCards";
import InViewAnimation from "@/components/utils/InViewAnimation";

export default function PageComponent({}) {
  return (
    <main className="page page-method">
      <div className="container-l">
        <InViewAnimation>
          <div className="page-title-holder">
            <h1 className="h1-title">
              <span className="shoulder">つくる革命</span>
              <span className="title en">Next Green Method</span>
            </h1>
            <div className="page-title-pic spOnly">
              <div className="video-holder">
                <video className="method" src="/assets/video/ngm.mp4" poster="/assets/img/method/top/ngr_circle.svg" loop autoPlay muted playsInline />
              </div>
            </div>
            <div className="text-lead">
              <div className="bold">土から健康な農業へ</div>
              <div className="small">
                誰もがどこでも実践できる、高収益でリスク耐性が高く、<br />
                地球環境にとってもいい農業へのシフトを<br className="spOnly" />ワンストップで支援します。
              </div>
            </div>
          </div>

          <section className="method-section">
            <div className="method-circulation-figure pcOnly">
              <div className="illust">
                <video className="method" src="/assets/video/ngm.mp4" poster="/assets/img/method/top/ngr_circle.svg" loop autoPlay muted playsInline />
              </div>
            </div>
            <MethodCards className="imageHover" />
          </section>
        </InViewAnimation>
      </div>
    </main>
  );
}
